export default "__VITE_ASSET__Bqy$shjO__"